import { __assign, __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef, useEffect, useState } from "react";
import { TabGroupWrapper } from "./styles";
import { SingleTab } from "../SingleTab";
export var TabGroup = forwardRef(function TabGroup(_a, ref) {
    var _b = _a.variant, variant = _b === void 0 ? "default" : _b, tabs = _a.tabs, _c = _a.defaultTab, defaultTab = _c === void 0 ? 0 : _c, onTabChange = _a.onTabChange, value = _a.value, tabStyles = _a.tabStyles, props = __rest(_a, ["variant", "tabs", "defaultTab", "onTabChange", "value", "tabStyles"]);
    var _d = useState(defaultTab), tabSelected = _d[0], setTabSelected = _d[1];
    useEffect(function () {
        if (typeof value === "number") {
            setTabSelected(value);
        }
    }, [value]);
    return (_jsx(TabGroupWrapper, __assign({ ref: ref }, props, { children: Array.isArray(tabs) &&
            tabs.map(function (tab, idx) {
                if (typeof tab === "string") {
                    return (_jsx(SingleTab, { style: tabStyles, isSelected: tabSelected === idx, onClick: function () {
                            setTabSelected(idx);
                            onTabChange === null || onTabChange === void 0 ? void 0 : onTabChange(idx);
                        }, variant: variant, children: tab }, idx));
                }
                return (_jsx(SingleTab, { style: tabStyles, isSelected: tabSelected === idx, onClick: function () {
                        setTabSelected(idx);
                        onTabChange === null || onTabChange === void 0 ? void 0 : onTabChange(idx);
                    }, variant: variant, icon: tab.icon, counter: tab.counter, children: tab.text }, idx));
            }) })));
});
//# sourceMappingURL=index.js.map